// extracted by mini-css-extract-plugin
export default {"Badge":"IconBadge_Badge__r4z-8","Blue":"IconBadge_Blue__b3+nJ","Gray":"IconBadge_Gray__JSlv6","Green":"IconBadge_Green__tNBPr"};